let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("k3BGs"), load("lgZ1d"), load("ffEVr"), load("joJy8"), load("aHE9G"), load("Pp5sV")]).then(() => parcelRequire('vRfNK'));